import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const update = (id,employee) =>
  requestsTemplates.put(mainPath, `/employees/${id}`,employee);
